/**
 *
 * ShiftDetailCardRoutes
 *
 */

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RoutesIcon from '@mui/icons-material/TransferWithinAStation';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ShiftDetailCardRouteItem from '../ShiftDetailCardRouteItem/index';
import messages from './messages';

const getIssuesForTurn = (
  issuesPerTurn: Array<{
    turn: {
      id: number;
    };
    issues: Array<{
      type?: string | null;
      severity?: string | null;
    }>;
  }>,
  turnId: number
) => issuesPerTurn.find((turnIssues) => turnIssues.turn.id === turnId);

type ShiftDetailCardRoutesProps = {
  turns: Array<{
    id: number;
    route: {
      id: number;
      name: string;
    };
    language?: string | null;
    turnAssignments: number[];
    isEnabled: boolean;
    isCanceled: boolean;
  }>;
  issues: Array<{
    turn: {
      id: number;
    };
    issues: Array<{
      type?: string | null;
      severity?: string | null;
    }>;
  }>;
  onPlanRoute: (turnId: number) => void;
  onPlanRoutes: () => void;
};

export const ShiftDetailCardRoutes = (props: ShiftDetailCardRoutesProps) => {
  const [expanded, setExpanded] = React.useState(true);

  const toggleExpand = () => setExpanded(!expanded);

  return (
    <Card>
      <CardHeader
        avatar={<RoutesIcon />}
        title={<FormattedMessage {...messages.header} />}
        subheader={
          <FormattedMessage
            {...messages.currentlyPlanned}
            values={{
              plannedTurns: props.turns.length.toString(),
            }}
          />
        }
        action={
          <IconButton onClick={toggleExpand} color="inherit" size="large">
            <ExpandMoreIcon
              style={{
                transform: `rotate(${expanded ? '180' : '0'}deg)`,
                transition: 'transform 300ms',
              }}
            />
          </IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider />
        {props.turns.length > 0 ? (
          <>
            <CardContent style={{ padding: 0 }}>
              <List>
                {props.turns.map((turn) => {
                  const issuesForTurn = getIssuesForTurn(props.issues, turn.id);
                  return (
                    <ShiftDetailCardRouteItem
                      key={turn.id}
                      turn={turn}
                      onPlanRoute={props.onPlanRoute}
                      issues={issuesForTurn ? issuesForTurn.issues : []}
                    />
                  );
                })}
              </List>
            </CardContent>
            <Divider />
            <CardActions>
              <Button onClick={props.onPlanRoutes}>
                <FormattedMessage {...messages.planRoutes} />
              </Button>
            </CardActions>
          </>
        ) : (
          <CardContent>
            <FormattedMessage {...messages.noApplications} />
          </CardContent>
        )}
      </Collapse>
    </Card>
  );
};

export default ShiftDetailCardRoutes;
